var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const LOGGER_STATE = {
  hasInitialized: false,
  /**
             * This log function remains empty until the logger has initialized
             */
  Log: () => {
  }
  // Empty log function
};
const MC_LOGGER_QUEUE_IS_FULL = "MC_LOGGER_QUEUE_IS_FULL";
const BATCH_LOGS_INTERNAL_STATE = {
  hasInitialized: false,
  /**
     * This stores a list of logs that will be dispatched using the log function
     */
  mainQueue: [],
  /**
    * This stores a list of objects that contain: {
    *    log // the log message
    *    payloadSize // the size of the data inside of that log
    * }
    * When the main queue is being processed new logs can be stored in this location
    * until the processing is finished
    */
  waitQueue: [],
  isBatchServiceActive: false,
  isProcessingMainQueue: false,
  configurablePropeties: {
    time: 6e3,
    // 6 seconds,
    maxQueueSize: 440
    // This is used to ensure the log data doesn't get to big that it can't be sent to the /track/log endpoint
  },
  batchServiceState: {
    /**
       * Stop all other actions and flush the queue.
       * If new logs come in dispatch them immediately
       */
    isPageNavigationOccuring: false,
    mainQueuePayloadSize: 0
  }
};
const convertQueueToObj = (queue) => {
  return queue.reduce((memo, curr) => {
    memo[curr.keyIndex] = __spreadValues({}, curr);
    delete memo[curr.keyIndex].keyIndex;
    return memo;
  }, {});
};
function flushQueue() {
  BATCH_LOGS_INTERNAL_STATE.isProcessingMainQueue = true;
  if (BATCH_LOGS_INTERNAL_STATE.mainQueue.length === 0) {
    BATCH_LOGS_INTERNAL_STATE.isProcessingMainQueue = false;
    return;
  }
  LOGGER_STATE.Log({
    message: "ECS Batch Logs",
    /**
     * Converts the Queue into an object where the keyIndex is the property names
     */
    data: convertQueueToObj(BATCH_LOGS_INTERNAL_STATE.mainQueue.slice())
  });
  const {
    newMainQueue,
    queuePayloadSize
  } = BATCH_LOGS_INTERNAL_STATE.waitQueue.reduce(
    (memo, curr) => {
      memo.newMainQueue.push(curr.log);
      memo.queuePayloadSize += curr.payLoadSize;
      return memo;
    },
    {
      newMainQueue: [],
      queuePayloadSize: 0
    }
  );
  BATCH_LOGS_INTERNAL_STATE.mainQueue = newMainQueue;
  BATCH_LOGS_INTERNAL_STATE.batchServiceState.mainQueuePayloadSize = queuePayloadSize;
  BATCH_LOGS_INTERNAL_STATE.isProcessingMainQueue = false;
  BATCH_LOGS_INTERNAL_STATE.waitQueue = [];
}
function checkIfQueueFull(payloadSize) {
  let isFull = false;
  const currentQueueSize = BATCH_LOGS_INTERNAL_STATE.batchServiceState.mainQueuePayloadSize;
  if (currentQueueSize + payloadSize >= BATCH_LOGS_INTERNAL_STATE.configurablePropeties.maxQueueSize) {
    isFull = true;
  }
  return isFull;
}
function getPayloadSize(payload) {
  return JSON.stringify(payload).length;
}
const batchLogService = () => {
  if (!BATCH_LOGS_INTERNAL_STATE.isBatchServiceActive && LOGGER_STATE.hasInitialized) {
    BATCH_LOGS_INTERNAL_STATE.isBatchServiceActive = true;
    window.addEventListener("beforeunload", () => {
      BATCH_LOGS_INTERNAL_STATE.batchServiceState.isPageNavigationOccuring = true;
      flushQueue();
    });
    window.addEventListener(MC_LOGGER_QUEUE_IS_FULL, () => {
      if (!BATCH_LOGS_INTERNAL_STATE.batchServiceState.isPageNavigationOccuring) {
        flushQueue();
      }
    });
    setInterval(() => {
      if (!BATCH_LOGS_INTERNAL_STATE.batchServiceState.isPageNavigationOccuring && !BATCH_LOGS_INTERNAL_STATE.isProcessingMainQueue) {
        flushQueue();
      }
    }, BATCH_LOGS_INTERNAL_STATE.configurablePropeties.time);
  }
};
const enqueueLog = (messageObj) => {
  if (BATCH_LOGS_INTERNAL_STATE.batchServiceState.isPageNavigationOccuring && LOGGER_STATE.hasInitialized) {
    LOGGER_STATE.Log({
      message: "ECS Batch Logs",
      data: convertQueueToObj(BATCH_LOGS_INTERNAL_STATE.mainQueue.slice())
    });
    return;
  }
  if (messageObj.keyIndex === void 0) {
    throw new Error("Invalid log configuration: no keyIndex");
  }
  const payLoadSize = getPayloadSize(messageObj.data);
  if (BATCH_LOGS_INTERNAL_STATE.isProcessingMainQueue) {
    BATCH_LOGS_INTERNAL_STATE.waitQueue.push({ log: messageObj, payLoadSize });
  } else {
    const isQueueFull = checkIfQueueFull(payLoadSize);
    if (isQueueFull) {
      window.dispatchEvent(new Event(MC_LOGGER_QUEUE_IS_FULL));
      BATCH_LOGS_INTERNAL_STATE.waitQueue.push({ log: messageObj, payLoadSize });
    } else {
      BATCH_LOGS_INTERNAL_STATE.mainQueue.push(messageObj);
      BATCH_LOGS_INTERNAL_STATE.batchServiceState.mainQueuePayloadSize += payLoadSize;
    }
  }
};
function BatchLog(messageObj) {
  messageObj.data = __spreadProps(__spreadValues({}, messageObj.data), {
    isError: false,
    log_timestamp: /* @__PURE__ */ new Date()
  });
  enqueueLog(messageObj);
}
function ErrorLog(messageObj) {
  const addedAttributes = {
    isError: true,
    log_timestamp: /* @__PURE__ */ new Date()
  };
  messageObj.data = __spreadValues(__spreadValues({}, messageObj.data), addedAttributes);
  LOGGER_STATE.Log(messageObj);
}
const initializeLogger = (loggerFunction) => {
  LOGGER_STATE.Log = loggerFunction;
  LOGGER_STATE.hasInitialized = true;
  batchLogService();
};
let _hasBrowserLibraryLoaded = false;
const Segment = {
  init,
  Analytics: {},
  attachAnalyticsToWindow
};
const isSegmentAnalyticsBrowser = (segment) => {
  return segment.track !== void 0;
};
function init(key, customOptions) {
  return __async(this, null, function* () {
    if (!_hasBrowserLibraryLoaded) {
      yield _initBrowser(key, customOptions);
      if (window.analytics != null) {
        Segment.Analytics = window.analytics;
      }
    } else {
      throw new Error("The library is already initialized");
    }
  });
}
function sleep(ms) {
  return __async(this, null, function* () {
    return yield new Promise((resolve) => setTimeout(resolve, ms));
  });
}
function _initBrowser(key, customOptions) {
  return __async(this, null, function* () {
    const analytics = attachAnalyticsToWindow(true);
    if (analytics === void 0)
      return;
    analytics.load = function(key2, options) {
      return __async(this, null, function* () {
        return yield new Promise((resolve, reject) => {
          const script = document.createElement("script");
          script.type = "text/javascript";
          script.async = true;
          script.addEventListener("load", function analyticsLoadEventListener() {
            resolve(void 0);
          }, { once: true });
          script.onerror = function analyticsLoadEventError() {
            reject(new Error("Failed to load script"));
          };
          script.src = "https://cdn.segment.com/analytics.js/v1/" + key2 + "/analytics.min.js";
          const first = document.getElementsByTagName("script")[0];
          if (first.parentNode != null) {
            first.parentNode.insertBefore(script, first);
          } else {
            ErrorLog({
              message: "The Segment Library has failed the first attempt to load",
              data: {
                step: "The library has failed to insert library script tag"
              }
            });
            throw new Error("Issue with launching script");
          }
          analytics._loadOptions = options;
        });
      });
    };
    analytics._writeKey = `${key}`;
    analytics.SNIPPET_VERSION = "4.15.3";
    let retryLoad = 0;
    let success = false;
    try {
      while (retryLoad < 3 && !success) {
        try {
          yield analytics.load(`${key}`, customOptions);
          success = true;
        } catch (error) {
          retryLoad++;
          if (retryLoad === 3) {
            throw new Error(error);
          }
          yield sleep(1e3);
        }
      }
      yield (() => __async(this, null, function* () {
        return yield new Promise((resolve) => {
          analytics.ready(() => {
            resolve();
          });
        });
      }))();
      _hasBrowserLibraryLoaded = true;
    } catch (e) {
      const scriptSrc = "https://cdn.segment.com/analytics.js/v1/" + key + "/analytics.min.js";
      let isTypeError = false;
      BatchLog({
        message: "The Segment Library has failed the first attempt to load",
        data: {
          step: "First attempt to load failed trying to see if adblocker is preventing the library from loading",
          error: e.message
        },
        keyIndex: "load_segment_failed_first"
      });
      try {
        const result = yield fetch(scriptSrc);
        const text = yield result.text();
        const first = document.getElementsByTagName("script")[0];
        if (first.parentNode != null && text !== "") {
          try {
            const script = document.createElement("script");
            script.type = "text/javascript";
            script.innerHTML = text;
            first.parentNode.insertBefore(script, first);
          } catch (err) {
            ErrorLog({
              message: "The Segment Library has failed the first attempt to load",
              data: {
                step: "The library has failed to insert library script code"
              }
            });
            throw new Error("Issue with launching script");
          }
          _hasBrowserLibraryLoaded = true;
          yield (() => __async(this, null, function* () {
            return yield new Promise((resolve) => {
              analytics.ready(() => {
                resolve();
              });
            });
          }))();
          return;
        }
        ErrorLog({
          message: "The Segment Library has failed the first attempt to load",
          data: {
            step: "The library has failed the second attempt to load via the script type text/javascript tag"
          }
        });
      } catch (err) {
        if (err instanceof TypeError) {
          isTypeError = true;
        } else {
          ErrorLog({
            message: "The Segment Library has failed the first attempt to load",
            data: {
              step: "The library has failed the second attempt to load",
              error: err
            }
          });
          console.error("The Segment Lbrary has failed to load. Attached is one of the error messages", JSON.stringify(err));
        }
      }
      window.analytics = void 0;
      console.error(`The Segment Lbrary has failed to load after retrying ${retryLoad} times. Attached is the final error message`, e.message);
      if (isTypeError) {
        throw new Error("Loading the Segment Library has failed due to it's resource request being blocked");
      }
    }
  });
}
function attachAnalyticsToWindow(isBeingInitialized) {
  const analytics = Segment.Analytics = window.analytics = window.analytics !== void 0 ? window.analytics : [];
  if (analytics.initialize !== void 0)
    return;
  if (isBeingInitialized !== void 0 && isBeingInitialized && analytics.invoked)
    return analytics;
  if (analytics.invoked) {
    return;
  }
  analytics.invoked = true;
  analytics.methods = [
    "trackSubmit",
    "trackClick",
    "trackLink",
    "trackForm",
    "pageview",
    "identify",
    "reset",
    "group",
    "track",
    "ready",
    "alias",
    "debug",
    "page",
    "once",
    "off",
    "on",
    "addSourceMiddleware",
    "addIntegrationMiddleware",
    "setAnonymousId",
    "addDestinationMiddleware"
  ];
  analytics.factory = function(method) {
    return function() {
      const args = Array.prototype.slice.call(arguments);
      args.unshift(method);
      analytics.push(args);
      return analytics;
    };
  };
  for (let i = 0; i < analytics.methods.length; i++) {
    const key = analytics.methods[i];
    analytics[key] = analytics.factory(key);
  }
  return analytics;
}
const AbortState = {
  abortAppfabricCreationEvent: new AbortController(),
  abortAppfabricInitialziedEvent: new AbortController(),
  abortInstanceDetectionEvent: new AbortController(),
  shouldAbortEverything: false,
  shouldAbortAppFabricListeners: false
};
const shouldAbortAllListeners = () => {
  AbortState.shouldAbortEverything = true;
  AbortState.abortAppfabricCreationEvent.abort();
  AbortState.abortAppfabricInitialziedEvent.abort();
  AbortState.abortInstanceDetectionEvent.abort();
};
const abortAppfabricListeners = () => {
  AbortState.abortAppfabricCreationEvent.abort();
  AbortState.abortAppfabricInitialziedEvent.abort();
};
const abortInstanceDetection = () => AbortState.abortInstanceDetectionEvent.abort();
const getAbortAppfabricCreationEventSignal = () => AbortState.abortAppfabricCreationEvent.signal;
const getAbortAppfabricInitialziedEventSignal = () => AbortState.abortAppfabricInitialziedEvent.signal;
const getAbortInstanceDetectionEventSignal = () => AbortState.abortInstanceDetectionEvent.signal;
const INSTANCE_DETECTION_LISTENER = "INSTANCE_DETECTION_LISTENER";
const DETECTED_INSTANCE_SHARING_STATE = "DETECTED_INSTANCE_SHARING_STATE";
const generateGlobalVariable = () => {
  if (!window.__MC_ECS_LIB) {
    window.__MC_ECS_LIB = {
      has_lib_init_started: false,
      has_appfabric_init_detection_listener_started: false
    };
  }
};
const getIfLibHasStartedInitializationProcess = () => {
  if (!window.__MC_ECS_LIB) {
    generateGlobalVariable();
    return false;
  }
  return window.__MC_ECS_LIB.has_lib_init_started;
};
const getIfAppFabricInitDetectionListenerHasStarted = () => {
  if (!window.__MC_ECS_LIB) {
    generateGlobalVariable();
    return false;
  }
  return window.__MC_ECS_LIB.has_appfabric_init_detection_listener_started;
};
const detectOtherInstanceListener = ({ internalState: internalState2, EcsTracking: EcsTracking2, LOGGER_STATE: LOGGER_STATE2, BATCH_LOGS_INTERNAL_STATE: BATCH_LOGS_INTERNAL_STATE2 }) => {
  window.addEventListener(INSTANCE_DETECTION_LISTENER, () => {
    window.dispatchEvent(new CustomEvent(DETECTED_INSTANCE_SHARING_STATE, {
      detail: {
        internalState: internalState2,
        EcsTracking: EcsTracking2,
        LOGGER_STATE: LOGGER_STATE2,
        BATCH_LOGS_INTERNAL_STATE: BATCH_LOGS_INTERNAL_STATE2
      },
      cancelable: false
    }));
  });
};
const listenForMainInstanceState = ({ internalState: internalState2, EcsTracking: EcsTracking2, LOGGER_STATE: LOGGER_STATE2, BATCH_LOGS_INTERNAL_STATE: BATCH_LOGS_INTERNAL_STATE2 }) => {
  let hasReceivedStateUpdateAlready = false;
  window.addEventListener(DETECTED_INSTANCE_SHARING_STATE, (event) => {
    if (!hasReceivedStateUpdateAlready && internalState2 !== event.detail.internalState) {
      hasReceivedStateUpdateAlready = true;
      Object.keys(event.detail.internalState).forEach((key) => {
        const eventInternals = event.detail.internalState[key];
        internalState2[key] = eventInternals;
      });
      Object.keys(event.detail.EcsTracking).forEach((key) => {
        const eventInternals = event.detail.EcsTracking[key];
        EcsTracking2[key] = eventInternals;
      });
      if (event.detail.LOGGER_STATE.hasInitialized) {
        if (Array.isArray(BATCH_LOGS_INTERNAL_STATE2.mainQueue)) {
          BATCH_LOGS_INTERNAL_STATE2.mainQueue.forEach((messageObj) => {
            if (event.detail.BATCH_LOGS_INTERNAL_STATE && event.detail.BATCH_LOGS_INTERNAL_STATE.mainQueue && Array.isArray(event.detail.BATCH_LOGS_INTERNAL_STATE.mainQueue)) {
              event.detail.BATCH_LOGS_INTERNAL_STATE.mainQueue.push(messageObj);
            }
          });
        }
      }
      LOGGER_STATE2 = event.detail.LOGGER_STATE;
      if (event.detail.BATCH_LOGS_INTERNAL_STATE) {
        BATCH_LOGS_INTERNAL_STATE2 = event.detail.BATCH_LOGS_INTERNAL_STATE;
      }
    }
    if (hasReceivedStateUpdateAlready) {
      abortInstanceDetection();
    }
  }, { signal: getAbortInstanceDetectionEventSignal() });
};
const alertMainInstanceWeHere = () => {
  window.dispatchEvent(new Event(INSTANCE_DETECTION_LISTENER, {
    cancelable: false
  }));
};
const alertOtherInstancesMainHasLoaded = ({ internalState: internalState2, EcsTracking: EcsTracking2, LOGGER_STATE: LOGGER_STATE2, BATCH_LOGS_INTERNAL_STATE: BATCH_LOGS_INTERNAL_STATE2 }) => {
  window.dispatchEvent(new CustomEvent(DETECTED_INSTANCE_SHARING_STATE, {
    detail: {
      internalState: internalState2,
      EcsTracking: EcsTracking2,
      LOGGER_STATE: LOGGER_STATE2,
      BATCH_LOGS_INTERNAL_STATE: BATCH_LOGS_INTERNAL_STATE2
    },
    cancelable: false
  }));
};
const APP_FABRIC_CREATION_EVENT = "appFabricInstanceCreated";
const APP_FABRIC_HAS_INTIALIZED_ECS = "appFabricHasInitialized_ecs";
const APP_FABRIC_ANALYTICS_EVENT_DATA = "appfabric-analytics-api-event-data";
const currentSystemState = {
  // Perform a check to see if the the AppFabric instance has already been created
  hasAppFabricInitialized: !!window.appFabricInstance
};
const has_appfabric_init_detection_listener_started = getIfAppFabricInitDetectionListenerHasStarted();
if (!currentSystemState.hasAppFabricInitialized && !has_appfabric_init_detection_listener_started) {
  window.__MC_ECS_LIB.has_appfabric_init_detection_listener_started = true;
  window.addEventListener(APP_FABRIC_CREATION_EVENT, () => {
    currentSystemState.hasAppFabricInitialized = true;
    window.dispatchEvent(new Event(APP_FABRIC_HAS_INTIALIZED_ECS));
  }, { signal: getAbortAppfabricCreationEventSignal() });
}
const detectIfAppFabricHasLoaded = (SegmentInstance, isInDebugMode) => __async(void 0, null, function* () {
  if (isInDebugMode) {
    console.log("mc_ecs_logs: Window.AppFabric available");
  }
  BatchLog({
    message: "ECS Tracking Library: AppFabric Initialize",
    data: {
      step: "detectIfAppFabricHasLoaded"
    },
    keyIndex: "appfabric_init_if_loaded"
  });
  return new Promise((resolve, reject) => {
    const promiseState = {
      hasPromiseResolved: false,
      /**
         * If the connectAppFabricsAnalytics function was triggered due to an event.
         * We want to make sure that the function only runs once even if multiple events are dispatched
         */
      hasEventBeenHandled: false
    };
    const connectAppFabricsAnalytics = () => __async(void 0, null, function* () {
      var _a, _b;
      if (isInDebugMode) {
        console.log("mc_ecs_logs: Connecting to Appfabric");
      }
      if (!promiseState.hasEventBeenHandled) {
        promiseState.hasEventBeenHandled = true;
      } else {
        return;
      }
      try {
        const apfInstance = window.appFabricInstance;
        let analyticsSubscriptionId;
        if ((_a = window.__shellInternal.segment) == null ? void 0 : _a.analytics) {
          if (isInDebugMode) {
            console.log("mc_ecs_logs: Appfabric Analytics library active. listening on events");
          }
          analyticsSubscriptionId = yield apfInstance.pubsub.subscribe(APP_FABRIC_ANALYTICS_EVENT_DATA, (data) => {
            var _a2;
            console.log("Host app received analytics data from appfabric-analytics-api-event-data topic", data);
            try {
              SegmentInstance.track(data);
              BatchLog({
                message: "ECS Tracking Library: AppFabric Initialize",
                data: {
                  step: "SegmentInstance track fired"
                },
                keyIndex: "appfabric_init_track_fired"
              });
            } catch (e) {
              ErrorLog({
                message: "ECS Tracking Library: AppFabric Initialize",
                data: {
                  step: "SegmentInstance track failed",
                  appFabricInstance: typeof apfInstance,
                  segmentAnalytics: typeof ((_a2 = window.__shellInternal.segment) == null ? void 0 : _a2.analytics)
                },
                keyIndex: "appfabric_init"
              });
            }
          });
          BatchLog({
            message: "ECS Tracking Library: AppFabric Initialize",
            data: {
              step: "apfInstance subscribe attempted",
              appFabricInstance: typeof apfInstance,
              segmentAnalytics: typeof ((_b = window.__shellInternal.segment) == null ? void 0 : _b.analytics)
            },
            keyIndex: "appfabric_init_track_attempted"
          });
        } else {
          if (isInDebugMode) {
            console.log("mc_ecs_logs: Appfabric Analytics library inActive. Launching initialize strategy");
          }
          let i = 0;
          let attemptAppFabricSegment;
          do {
            try {
              yield apfInstance.analytics.init();
              i++;
              attemptAppFabricSegment = false;
            } catch (e) {
              attemptAppFabricSegment = true;
              ErrorLog({
                message: "ECS Tracking Library: AppFabric Initialize",
                data: {
                  step: "AppFabric failed to initialize"
                },
                keyIndex: "appfabric_init_failed_init"
              });
            }
          } while (i < 2 && attemptAppFabricSegment);
        }
        delete window.__shellInternal.segment.analytics;
        delete window.appFabricInstance.analytics;
        Object.defineProperty(window.__shellInternal.segment, "analytics", {
          value: SegmentInstance,
          writable: false
        });
        Object.defineProperty(window.appFabricInstance, "analytics", {
          value: SegmentInstance,
          writable: false
        });
        if (isInDebugMode) {
          console.log("mc_ecs_logs: Converted AppFabric Analytics to this library");
        }
        if (analyticsSubscriptionId) {
          apfInstance.pubsub.unsubscribe(analyticsSubscriptionId);
          BatchLog({
            message: "ECS Tracking Library: AppFabric Initialize",
            data: {
              step: "AppFabric unsubscribe"
            },
            keyIndex: "appfabric_init_unsubscribe"
          });
        }
        resolve(true);
        promiseState.hasPromiseResolved = true;
      } catch (e) {
        if (isInDebugMode) {
          console.log("mc_ecs_logs: Error with connecting to Appfabric analytics");
          console.error(e);
        }
        BatchLog({
          message: "ECS Tracking Library: AppFabric Initialize",
          data: {
            step: "AppFabric Error with connecting to Appfabric analytics"
          },
          keyIndex: "appfabric_init_error_connect"
        });
        reject(e);
        promiseState.hasPromiseResolved = true;
      }
    });
    if (!window.AppFabric || !window.appFabricInstance) {
      if (isInDebugMode) {
        console.log("mc_ecs_logs: Waiting for AppFabric Initialization Event");
      }
      getAbortAppfabricInitialziedEventSignal().addEventListener("abort", () => {
        if (!promiseState.hasPromiseResolved) {
          resolve(false);
        }
      });
      BatchLog({
        message: "ECS Tracking Library: AppFabric Initialize",
        data: {
          step: "Listener with getAbortAppfabricInitialziedEventSignal"
        },
        keyIndex: "appfabric_init_listener"
      });
      window.addEventListener(APP_FABRIC_HAS_INTIALIZED_ECS, connectAppFabricsAnalytics, { signal: getAbortAppfabricInitialziedEventSignal() });
    } else {
      if (isInDebugMode) {
        console.log("mc_ecs_logs: AppFabrics is initialized attempting to connect to it");
      }
      BatchLog({
        message: "ECS Tracking Library: AppFabric Initialize",
        data: {
          step: "connectAppFabricsAnalytics resolve"
        },
        keyIndex: "appfabric_init_resolve"
      });
      connectAppFabricsAnalytics().then(resolve).catch(reject);
    }
  });
});
const enrichmentMiddleware = (defaultProperties) => ({ payload, next }) => {
  switch (payload.obj.type) {
    case "track": {
      if (payload.obj.properties.event_sender_app_id) {
        const propertiesToAdd = __spreadValues(__spreadValues(__spreadValues({}, defaultProperties == null ? void 0 : defaultProperties.track), defaultProperties == null ? void 0 : defaultProperties.all), defaultProperties == null ? void 0 : defaultProperties.userSessionInfo);
        payload.obj.context = __spreadValues(__spreadValues({
          /**
           * This property will be added to the 'context' object of events from appfabric
           * If this property is defined on an appfabric event then it will be overriden by the value from appfabric
           */
          initiative_name: "appfabric"
        }, payload.obj.context), propertiesToAdd);
        payload.obj.properties = __spreadValues(__spreadValues({
          /**
           * This property will be added to the 'properties' object of events from appfabric
           * If this property is defined on an appfabric event then it will be overriden by the value from appfabric
           */
          initiative_name: "appfabric"
        }, payload.obj.properties), propertiesToAdd);
      }
      break;
    }
    case "identify": {
      break;
    }
    default: {
      console.warn("unsupported event type: ", payload.obj.type);
    }
  }
  next(payload);
};
const REQUIRED_PROPS = ["object", "action", "org", "purpose", "scope", "initiative_name"];
const REQUIRED_DYNAMIC_PROPS = ["object", "action", "org", "purpose", "scope"];
const dropEventsMiddleware = ({ payload, next }) => {
  if (payload.obj.type === "track") {
    if (payload.obj.properties["__mc-dynamic-eventing"]) {
      for (const prop of REQUIRED_DYNAMIC_PROPS) {
        if (!payload.obj.properties[prop]) {
          BatchLog({
            message: "Event Dropped",
            data: {
              eventObject: payload.obj,
              fullContext: payload,
              requiredProp: prop
            },
            keyIndex: "dropped_event"
          });
          console.warn("Dropping event because it doesn't contain the required property: ", prop, payload.obj);
          return;
        }
      }
    } else {
      for (const prop of REQUIRED_PROPS) {
        if (!payload.obj.properties[prop]) {
          BatchLog({
            message: "Event Dropped",
            data: {
              eventObject: payload.obj,
              fullContext: payload,
              requiredProp: prop
            },
            keyIndex: "dropped_event"
          });
          console.warn("Dropping event because it doesn't contain the required property: ", prop, payload.obj);
          return;
        }
      }
    }
  }
  next(payload);
};
const overrideList = [
  "locale",
  "page",
  "userAgentData",
  "userAgent"
];
const allowListMiddleware = (allowList) => ({ payload, next }) => {
  if (!allowList) {
    next(payload);
    return;
  }
  const allowListProperties = [
    ...REQUIRED_PROPS,
    ...allowList
  ];
  const eventContextObj = {};
  for (const property of allowListProperties) {
    if (payload.obj.context[property]) {
      eventContextObj[property] = payload.obj.context[property];
    }
  }
  const tempSet = new Set(allowList);
  if (!tempSet.has("ip")) {
    eventContextObj.ip = "0.0.0.0";
  }
  for (const prop of overrideList) {
    if (!tempSet.has(prop)) {
      eventContextObj[prop] = null;
    }
  }
  payload.obj.context = eventContextObj;
  next(payload);
};
const validateEmptyObject = (internalState2, eventObject, localOverrides = {}) => {
  if (eventObject === void 0 || eventObject === null) {
    BatchLog({
      message: "Track: Blocked Event",
      data: {
        eventObject,
        localOverrides
      },
      keyIndex: "blocked_event_emptyObject"
    });
    if (internalState2.isInDebugMode) {
      throw new Error("The 'eventObject' is required for sending events. Please refer to the ECS standard doc");
    } else {
      console.trace();
      console.warn("The 'eventObject' is required for sending events. Please refer to the ECS standard doc");
    }
  }
};
const validateEventObjectandAction = (internalState2, eventObject, errorSource = "library") => {
  if (eventObject.object === void 0 || eventObject.action === void 0) {
    BatchLog({
      message: "Track: Blocked Event",
      data: {
        eventObject,
        missingField: {
          object: eventObject.object === void 0,
          action: eventObject.action === void 0
        }
      },
      keyIndex: "blocked_event_missing_object_action"
    });
    let consoleError = "There is an issue with missing or incorrectly spelled action or object properties in your ECS event setup.";
    if (errorSource !== "library") {
      consoleError = "There is an issue with missing or incorrectly spelled action or object properties in your Authoring Tool tracking plan.";
    }
    if (internalState2.isInDebugMode) {
      throw new Error(consoleError);
    } else {
      console.trace();
      console.error(consoleError);
    }
  }
};
const validateEventSource = (internalState2, eventObject, source, localOverrides = {}) => {
  if (eventObject[source] !== Symbol.for("__mc-ecs-storage") && eventObject[source] !== Symbol.for("__mc-dynamic-eventing")) {
    BatchLog({
      message: "Track: Invalid Event",
      data: {
        eventObject,
        localOverrides,
        /**
         * Tracking if this is occuring in prod or dev
         */
        isDev: internalState2.isInDebugMode
      },
      keyIndex: "invalid_event"
    });
    if (internalState2.isInDebugMode) {
      console.trace();
      console.warn(`The track event does not originate with '${source}'`);
      console.warn("Please reach out to the mc-ecs-event-help channel for support");
      console.warn("Event: ", JSON.stringify(eventObject, null, 2));
    }
  }
};
const validateCustomProperties = (internalState2, eventObject, localOverrides = {}) => {
  for (const key in localOverrides) {
    if (eventObject[key] === void 0) {
      BatchLog({
        message: "Track: Blocked Event",
        data: {
          eventObject,
          localOverrides,
          invalidCustomProperties: true
        },
        keyIndex: `blocked_event_${key}`
      });
      if (internalState2.isInDebugMode) {
        throw new Error(`Custom Properties can't be added to this event object: ${key}`);
      } else {
        console.trace();
        console.warn(`Custom Properties can't be added to this event object: ${key}`);
        return;
      }
    }
    if (internalState2.validator !== void 0) {
      const isValid = internalState2.validator.track(localOverrides[key]);
      if (!isValid) {
        BatchLog({
          message: "Track: Blocked Event",
          data: {
            eventObject,
            localOverrides,
            invalidProperty: true
          },
          keyIndex: `blocked_event_${key}`
        });
        if (internalState2.isInDebugMode) {
          throw new Error(`The value: ${localOverrides[key]} provided to the property ${key} is invalid `);
        } else {
          console.trace();
          console.warn(`The value: ${localOverrides[key]} provided to the property ${key} is invalid `);
          return;
        }
      }
    }
  }
};
const validateValidProperties = (internalState2, eventObject, localOverrides = {}) => {
  if (internalState2.validator !== void 0) {
    for (const key in eventObject) {
      const isValid = internalState2.validator.track(eventObject[key]);
      if (!isValid) {
        BatchLog({
          message: "Track: Blocked Event",
          data: {
            eventObject,
            localOverrides,
            invalidProperty: true
          },
          keyIndex: `blocked_event_${key}`
        });
        if (internalState2.isInDebugMode) {
          throw new Error(`The value: ${eventObject[key]} provided to the property ${key} is invalid `);
        } else {
          console.trace();
          console.warn(`The value: ${eventObject[key]} provided to the property ${key} is invalid `);
          return;
        }
      }
    }
  }
};
const ENVIRONMENT_IS_WEB = typeof window === "object";
const ENVIRONMENT_IS_WORKER = typeof importScripts === "function";
if (ENVIRONMENT_IS_WORKER) {
  throw new Error("This library cannot be used inside of a web worker");
}
if (!ENVIRONMENT_IS_WEB) {
  throw new Error("This library can only be used on the web");
}
const internalState = {
  userSessionInfo: {},
  isInDebugMode: false,
  hasQueueFlushed: false,
  // These properties wil be added to the context property of the track event
  track: {},
  // These properties will be added to the context property of the identify event
  identify: {},
  // These properties will be added to the context field for both track and identify
  all: {},
  /**
   * Store the current instance of Segment inside of the internalState.
   * This can be updated later if another instance of this library is
   * running on the page
   */
  Segment
};
const EcsTracking = {
  hasInitialized: false,
  initialize,
  track,
  identify,
  debug,
  dynamicTrack
};
const hasLibInitStarted = getIfLibHasStartedInitializationProcess();
Segment.attachAnalyticsToWindow();
listenForMainInstanceState({ internalState, EcsTracking, LOGGER_STATE, BATCH_LOGS_INTERNAL_STATE });
if (hasLibInitStarted) {
  alertMainInstanceWeHere();
}
function initialize(_0, _1, _2) {
  return __async(this, arguments, function* (writeKey, customSegmentLibraryOptions, defaultProperties, customEcsConfiguration = { cancelAllListeners: false, cancelAppfabricListeners: false, loggerFunction: () => {
  } }) {
    var _a;
    if (writeKey === "" || writeKey === void 0) {
      throw new Error("Missing Write Key");
    }
    initializeLogger(customEcsConfiguration.loggerFunction);
    if (window.__MC_ECS_LIB.has_lib_init_started) {
      return;
    } else {
      if (customEcsConfiguration.validator !== void 0) {
        internalState.validator = customEcsConfiguration.validator;
      }
      detectOtherInstanceListener({ internalState, EcsTracking, LOGGER_STATE, BATCH_LOGS_INTERNAL_STATE });
      window.__MC_ECS_LIB.has_lib_init_started = true;
      alertOtherInstancesMainHasLoaded({ internalState, EcsTracking, LOGGER_STATE, BATCH_LOGS_INTERNAL_STATE });
    }
    for (const key in defaultProperties) {
      const property = defaultProperties[key];
      internalState[key] = property;
    }
    if (customEcsConfiguration.cancelAllListeners) {
      shouldAbortAllListeners();
    } else if (customEcsConfiguration.cancelAppfabricListeners) {
      abortAppfabricListeners();
    }
    const defaultSegmentLibraryOptions = __spreadProps(__spreadValues({}, customSegmentLibraryOptions), {
      user: {
        persist: false
        // Prevent the library from storing users id locally.
      }
    });
    if (customSegmentLibraryOptions.integrations !== void 0) {
      defaultSegmentLibraryOptions.integrations = customSegmentLibraryOptions.integrations;
    }
    if (customSegmentLibraryOptions.user !== void 0) {
      defaultSegmentLibraryOptions.user = __spreadValues(__spreadValues({}, defaultSegmentLibraryOptions.user), customSegmentLibraryOptions.user);
    }
    if (window.analytics !== void 0) {
      window.analytics.addSourceMiddleware(enrichmentMiddleware(defaultProperties));
      window.analytics.addSourceMiddleware(dropEventsMiddleware);
      window.analytics.addSourceMiddleware(allowListMiddleware(defaultProperties == null ? void 0 : defaultProperties.allowList));
    }
    if (!EcsTracking.hasInitialized) {
      if (Array.isArray(window.analytics)) {
        for (const event of window.analytics) {
          if (event[0] === "track") {
            event[2] = __spreadValues(__spreadValues(__spreadValues(__spreadValues({}, event[2]), defaultProperties == null ? void 0 : defaultProperties.all), defaultProperties == null ? void 0 : defaultProperties.track), defaultProperties == null ? void 0 : defaultProperties.userSessionInfo);
            event[3] = {
              context: __spreadValues(__spreadValues(__spreadValues(__spreadValues({}, event[3].context), defaultProperties == null ? void 0 : defaultProperties.all), defaultProperties == null ? void 0 : defaultProperties.track), defaultProperties == null ? void 0 : defaultProperties.userSessionInfo)
            };
          }
        }
      }
      try {
        yield Segment.init(writeKey, defaultSegmentLibraryOptions);
      } catch (e) {
        BatchLog({
          message: "ECS Tracking Library: initialize function",
          data: {
            step: "The Analytics library failed to initialize: Ad blocker detected",
            hasLibraryInitialized: false
          },
          keyIndex: "ad_blocker_detected"
        });
        console.warn("The Analytics library failed to initialize. This is most likely due to an adblocker. If you're using an adblocker please disable it and try again");
        EcsTracking.hasInitialized = false;
        shouldAbortAllListeners();
        return;
      }
      EcsTracking.hasInitialized = !(((_a = window.analytics) == null ? void 0 : _a.initialize) == null);
      if (!EcsTracking.hasInitialized) {
        ErrorLog({
          message: "ECS Tracking Library: initialize function",
          data: {
            step: "The Analytics library failed to initialize",
            hasLibraryInitialized: false
          }
        });
        throw new Error("Analytics library failed to initialize. Please inspect the library initialization process");
      } else {
        if (window.analytics !== void 0 && !customEcsConfiguration.cancelAllListeners) {
          if (!customEcsConfiguration.cancelAppfabricListeners) {
            const timeoutId = setTimeout(() => {
              abortAppfabricListeners();
            }, 3e5);
            detectIfAppFabricHasLoaded(window.analytics, internalState.isInDebugMode).catch((error) => {
              ErrorLog({
                message: "ECS Tracking Library: initialize function",
                data: {
                  step: "Appfabric detection failed"
                }
              });
              console.error(error);
            }).finally(() => {
              clearTimeout(timeoutId);
              abortAppfabricListeners();
            });
          }
        }
      }
    }
  });
}
function track(eventObject, localOverrides) {
  if (eventObject === void 0 || eventObject === null) {
    BatchLog({
      message: "Track: Blocked Event",
      data: {
        eventObject,
        localOverrides
      },
      keyIndex: "blocked_event_emptyObject"
    });
    if (internalState.isInDebugMode) {
      throw new Error("The 'eventObject' is required for sending events. Please refer to the ECS standard doc");
    } else {
      console.trace();
      console.warn("The 'eventObject' is required for sending events. Please refer to the ECS standard doc");
      return;
    }
  }
  if (eventObject.object === void 0 || eventObject.action === void 0) {
    BatchLog({
      message: "Track: Blocked Event",
      data: {
        eventObject,
        missingField: {
          object: eventObject.object === void 0,
          action: eventObject.action === void 0
        }
      },
      keyIndex: "blocked_event_missing_object_action"
    });
    if (internalState.isInDebugMode) {
      throw new Error("The 'object' and 'action' property are required for sending events. Please refer to the ECS standard doc");
    } else {
      console.trace();
      console.warn("The 'object' and 'action' property are required for sending events. Please refer to the ECS standard doc");
      return;
    }
  }
  if (eventObject["__mc-ecs-storage"] !== Symbol.for("__mc-ecs-storage")) {
    BatchLog({
      message: "Track: Invalid Event",
      data: {
        eventObject,
        localOverrides,
        /**
         * Tracking if this is occuring in prod or dev
         */
        isDev: internalState.isInDebugMode
      },
      keyIndex: "invalid_event"
    });
    if (internalState.isInDebugMode) {
      console.trace();
      console.warn("The track event does not originate from the mc-ecs-storage");
      console.warn("Please reach out to the mc-ecs-event-help channel for support");
      console.warn("Event: ", JSON.stringify(eventObject, null, 2));
    }
  }
  for (const key in localOverrides) {
    if (eventObject[key] === void 0) {
      BatchLog({
        message: "Track: Blocked Event",
        data: {
          eventObject,
          localOverrides,
          invalidCustomProperties: true
        },
        keyIndex: `blocked_event_${key}`
      });
      if (internalState.isInDebugMode) {
        throw new Error(`Custom Properties can't be added to this event object: ${key}`);
      } else {
        console.trace();
        console.warn(`Custom Properties can't be added to this event object: ${key}`);
        return;
      }
    }
    if (internalState.validator !== void 0) {
      const isValid = internalState.validator.track(localOverrides[key]);
      if (!isValid) {
        BatchLog({
          message: "Track: Blocked Event",
          data: {
            eventObject,
            localOverrides,
            invalidProperty: true
          },
          keyIndex: `blocked_event_${key}`
        });
        if (internalState.isInDebugMode) {
          throw new Error(`The value: ${localOverrides[key]} provided to the property ${key} is invalid `);
        } else {
          console.trace();
          console.warn(`The value: ${localOverrides[key]} provided to the property ${key} is invalid `);
          return;
        }
      }
    }
  }
  if (internalState.validator !== void 0) {
    for (const key in eventObject) {
      const isValid = internalState.validator.track(eventObject[key]);
      if (!isValid) {
        BatchLog({
          message: "Track: Blocked Event",
          data: {
            eventObject,
            localOverrides,
            invalidProperty: true
          },
          keyIndex: `blocked_event_${key}`
        });
        if (internalState.isInDebugMode) {
          throw new Error(`The value: ${eventObject[key]} provided to the property ${key} is invalid `);
        } else {
          console.trace();
          console.warn(`The value: ${eventObject[key]} provided to the property ${key} is invalid `);
          return;
        }
      }
    }
  }
  if (isSegmentAnalyticsBrowser(Segment.Analytics)) {
    const defaultProperties = __spreadValues(__spreadValues(__spreadValues({}, eventObject), localOverrides), internalState.userSessionInfo);
    const additionalContext = {
      context: __spreadValues(__spreadValues(__spreadValues({}, internalState.all), internalState.track), internalState.userSessionInfo)
    };
    internalState.Segment.Analytics.track(`${defaultProperties.object}:${defaultProperties.action}`, defaultProperties, additionalContext);
  }
}
function dynamicTrack(dynamicConfig, dynamicId, eventProperties) {
  return __async(this, null, function* () {
    const webEventing = yield import("./index-7100f992.js").then((n) => n.i);
    const eventingInstance = new webEventing.BaseEventing({
      eventHandler: () => {
      },
      errorHandler: (event2) => {
        if (event2 !== "Dynamic_Eventing_Validation_Error") {
          ErrorLog({
            message: "ECS Dynamic Web Eventing Error",
            data: {
              event_data: event2,
              config_url: dynamicConfig,
              dynamic_id: dynamicId,
              event_properties: eventProperties
            }
          });
          if (internalState.isInDebugMode) {
            console.error(
              "Authoring Tool Error: " + event2 + "\nDynamic ID: " + dynamicId + "\nConfig URL: " + dynamicConfig
            );
          }
        }
      },
      sourceData: {
        url: dynamicConfig,
        fallbackData: {},
        backupUrl: ""
      }
    });
    validateEventSource(internalState, eventProperties, "__mc-dynamic-eventing");
    const getDynamicEvent = eventingInstance.handleEvent(dynamicId, {}, {});
    const event = yield getDynamicEvent;
    if (isSegmentAnalyticsBrowser(Segment.Analytics)) {
      const defaultProperties = __spreadValues(__spreadValues(__spreadValues({}, event), eventProperties), internalState.userSessionInfo);
      const additionalContext = {
        context: __spreadValues(__spreadValues(__spreadValues({}, internalState.all), internalState.track), internalState.userSessionInfo)
      };
      Object.defineProperty(defaultProperties, "__mc-dynamic-eventing", {
        value: Symbol.for("__mc-dynamic-eventing"),
        enumerable: false,
        writable: false,
        configurable: false
      });
      validateEmptyObject(internalState, defaultProperties);
      validateEventObjectandAction(internalState, defaultProperties, "authoring-tool");
      validateCustomProperties(internalState, defaultProperties);
      validateValidProperties(internalState, defaultProperties);
      if ((!(defaultProperties == null ? void 0 : defaultProperties.screen) || (defaultProperties == null ? void 0 : defaultProperties.screen) === "<auto-populated>") && (defaultProperties == null ? void 0 : defaultProperties.dynamic_screen)) {
        defaultProperties.screen = defaultProperties.dynamic_screen;
      }
      internalState.Segment.Analytics.track(`${defaultProperties.object}:${defaultProperties.action}`, defaultProperties, additionalContext);
    }
  });
}
function identify(userId, traits) {
  if (userId === "") {
    throw new Error("A user id will need to be provided when using this function");
  }
  internalState.__userId = userId;
  if (isSegmentAnalyticsBrowser(Segment.Analytics)) {
    internalState.userSessionInfo = __spreadValues({
      user_id: userId
    }, traits);
    const additionalContext = {
      context: __spreadValues(__spreadValues(__spreadValues({}, internalState.all), internalState.identify), internalState.userSessionInfo)
    };
    internalState.Segment.Analytics.identify(userId, traits, additionalContext);
  }
}
function debug() {
  if (!internalState.isInDebugMode) {
    console.warn("DEBUGGER INITIALIZED");
    internalState.isInDebugMode = true;
    if (isSegmentAnalyticsBrowser(Segment.Analytics)) {
      internalState.Segment.Analytics.debug(true);
      const eventList = [
        "initialize",
        "call_after_close",
        "screen",
        "identify",
        "group",
        "track",
        "ready",
        "alias",
        "page",
        "error",
        "register",
        "deregister"
      ];
      for (const eventListener of eventList) {
        internalState.Segment.Analytics.on(eventListener, (event, properties, options) => {
          console.warn("Current Event: ", event);
          console.warn("Properties", properties);
          console.warn("Options", options);
        });
      }
    }
  }
}
export {
  EcsTracking as default
};
